import { render, staticRenderFns } from "./CollapseTaskByTaskType.vue?vue&type=template&id=b9d9aec2&"
import script from "./CollapseTaskByTaskType.vue?vue&type=script&lang=js&"
export * from "./CollapseTaskByTaskType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports